import {SubProduct} from "./product.model";
import {Characteristics} from "./characteristics.model";


export interface ISubProductCharacteristic{
  id?: number;
  subProduct?: SubProduct;
  characteristic?: Characteristics;
  value?: string;
}

export class SubProductCharacteristic implements ISubProductCharacteristic{
  constructor(
    public id?: number,
    public subProduct?: SubProduct,
    public characteristic?: Characteristics,
    public value?: string,
  ){
    this.id = id;
    this.subProduct = subProduct;
    this.characteristic = characteristic;
    this.value = value;
  }
}
